import React from "react";
import "./Footer.css";
export const Footer = () => {
    return <div className="footer">© COPYRIGHT 2023 KAI TSZ TECHNOLOGY</div>;
};
